import { apiRequest } from "../common/requestwithdata";
import { ExamResultApiModel, FinalResultViewModel, ExamTemplateMappingInfo } from "../types/result";

// api/User/Register

const RESULT_ROUTE = "api/ExamResult";
const STUDENT_RESULT_BY_EXAM_PROGRESS_ID = '/GetExamResultByExamProgressId';
const STUDENT_RESULTBYEXAM_PROGRESSID = '/GetExamResult_ByExmProgessId';

export const GetExamResultByExamProgressId = async (ExamProgressId: number) => {

    const result = await apiRequest<typeof ExamProgressId, ExamResultApiModel>(
        `/${RESULT_ROUTE}${STUDENT_RESULT_BY_EXAM_PROGRESS_ID}`,
        "POST",
        ExamProgressId
    );
    if (result.success) {
        return result.data; // Return the packages data
    } else {
        console.log("Error Submit  questions:", result.errors);
        return null;
    }
}
export const GetExamResult_ByExamProgressId = async (ExamProgressId: number) => {

    const result = await apiRequest<typeof ExamProgressId, FinalResultViewModel>(
        `/${RESULT_ROUTE}${STUDENT_RESULTBYEXAM_PROGRESSID}`,
        "POST",
        ExamProgressId
    );
    if (result.success) {
        return result.data; // Return the packages data
    } else {
        console.log("Error Submit  questions:", result.errors);
        return null;
    }
}

export const GetExamTemplateMappings = async () => {
    const result = await apiRequest<number, ExamTemplateMappingInfo[]>(
        `/${RESULT_ROUTE}/GetExamTemplateMappings`,
        "POST",
        0
    );
    if (result.success) {
        return result.data;
    } else {
        console.log("Error fetching template mappings:", result.errors);
        return null;
    }
}

